// @flow
import types from "./types";
import type {LatLngLiteral} from "../../../Utils/MapUtils";
import type {AlertData, CSSDirectionType} from "./utils";

const acceptTerms = () => ({type: types.TERMS_BUTTON_CLICK,});
const loadingSemaphoreIncrement = () => ({type: types.LOADING_SEMAPHORE_INCREMENT,});
const loadingSemaphoreDecrement = () => ({type: types.LOADING_SEMAPHORE_DECREMENT,});
const updateRiderLocation = (riderLocation?: LatLngLiteral) => ({
    type: types.RIDER_LOCATION_UPDATE,
    payload: riderLocation,
});

const alertDataSet = (alert: AlertData) => ({type: types.ALERT_DATA_SET, payload: alert});
const alertDataClear = () => ({type: types.ALERT_DATA_CLEAR});
const noOperation = () => ({type: types.NO_OPERATION});
const technicalIssue = () => ({type: types.BLOCKING_TECHNICAL_ISSUE});
const updateDirection = (direction: CSSDirectionType) => ({type: types.CSS_DIRECTION_SET, payload: direction});

export default {
    acceptTerms,
    loadingSemaphoreIncrement,
    loadingSemaphoreDecrement,
    updateRiderLocation,
    alertDataSet,
    alertDataClear,
    noOperation,
    technicalIssue,
    updateDirection,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/App/actions.js